import React, {Component} from 'react'
import Header from "../components/header"
import MainNav from "../components/mainNav"
import Footer from "../components/footer"
import '../../static/css/style.scss'
import api from "../../api/api"
import $ from "jquery"
import InfiniteScroll from 'react-infinite-scroller'
import Notdata from "../components/notdata"
class Teachers extends Component {
	state={
		currentPage:1,
		pageSize:20,
		finished:false,
		hasMore:true,
		navs:[
			{name:'首页',link:'/'},
			{name:'师资团队',link:'/teachers'},
		],
		list:[]
	}
	componentDidMount() {
		this.getList()
	}
	getList=async ()=>{
		let {currentPage,pageSize,finished,list}=this.state
		if (finished){
			return
		}
		let res=await api.get('/advisers/get-list',{currentPage,pageSize})
		let temp=[]
		if (currentPage===1){
			temp=res.data.data
		}else {
			temp=[...list,...res.data.data]
		}
		this.setState({
			list:temp,
		},()=>{
			let total=res.data.total
			if (this.state.list.length>=total){
				this.setState({hasMore:false,finished:true})
			}else {
				this.setState({hasMore:true})
			}
		})
	}
	render() {
		let {navs,list,currentPage,hasMore}=this.state
		return (
			<div className={'page'}>
				<Header/>
				<div className={'main'}>
					<MainNav navs={navs}/>
					{
						list.length?(
							<InfiniteScroll
								hasMore={hasMore}
								useWindow={true}
								initialLoad={false}
								loadMore={()=>{
									currentPage++
									this.setState({currentPage,hasMore:false},()=>{
										this.getList()
									})
								}}
							>
								<div className={'teachers'}>
									{
										list.map((item,index)=>(
											<div className={'teachers_item'} key={index}>
												<img src={item.avatar} alt=""/>
												<div className={'teacher_text'}>
													<div className={'teacher_name'}>{item.name}</div>
													<div className={'teacher_title'}>{item.title}</div>
													<div className={'teacher_info'} dangerouslySetInnerHTML={{__html:item.intro}}/>
												</div>
												<img className={'zixunicon'} onClick={()=>{$('#nb_invite_ok').click()}} src={require('../../static/images/zixun.png')} alt=""/>
											</div>
										))
									}
								</div>
							</InfiniteScroll>
						):<Notdata/>
					}
				</div>
				<Footer/>
			</div>
		)
	}
}

export default Teachers